import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";
import { confirmProcess } from "../context/Customfunction";

const useSocketConnection = (url) => {
  const [socket, setSocket] = useState(null);
  const [serverResponse] = useState(null);
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.authUser?.data);
  const previousMergedClips = useSelector((state) => state?.LiveFeed?.mergerdClip || []);

  useEffect(() => {
    const newSocket = io("https://visionfiredetectionapi.greymatterz.com", {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 1,
      reconnectionDelay: 5000,
    });
    // const newSocket = io("ws://192.168.0.246:5001", {
    //   transports: ["websocket"],
    // });

    newSocket.on("connect", () => {
      //console.log("Sarver connected!!:");
    });

    newSocket.on("disconnect", () => {
      //console.log("Disconnected from WebSocket server");
    });

    newSocket.on("message", () => {
      //console.log("Message from server:");
    });

    newSocket.on("processing_complete", (data) => {
      ////console.log("Received document update:", data);
      if (data) {
        // dispatch(
        //   SetMergerdClip([...previousMergedClips, data.merged_video_url])
        // );
      }
      confirmProcess();
    });

    return () => {
      newSocket.disconnect();
    };
  }, [dispatch, previousMergedClips]);
  return { socket, serverResponse };
};

export default useSocketConnection;
